/**
 * Playback lifecycle states — single source of truth for UI + plugins.
 */
export const PlaybackState = Object.freeze({
  IDLE: "idle",
  LOADING: "loading",
  READY: "ready",
  PLAYING: "playing",
  PAUSED: "paused",
  BUFFERING: "buffering",
  SEEKING: "seeking",
  ENDED: "ended",
  ERROR: "error",
});

export const PLAYBACK_STATE_VALUES = Object.keys(PlaybackState).map(function (k) {
  return PlaybackState[k];
});

/**
 * @param {string} state
 * @returns {boolean}
 */
export function isActivePlayback(state) {
  return (
    state === PlaybackState.PLAYING ||
    state === PlaybackState.BUFFERING ||
    state === PlaybackState.SEEKING
  );
}

export default PlaybackState;
